import { useCallback, useEffect, useRef, useState } from "react";
import { useParams } from "react-router-dom";
import { useCommunity } from "@contexts/CommunityContext";

import api from "@helpers/api";
import { adaptEnrollmentDetail } from "../../../helpers/apiAdapters";

export default function useEnrollmentDetail(programId, enrollmentId) {
  const { slug } = useParams();
  const { community, loading: communityLoading } = useCommunity();
  const currentCommunity = community.getBySlug(slug);
  const communityId = currentCommunity?.id;

  const [enrollment, setEnrollment] = useState(null);
  const [loading, setLoading] = useState(true);
  const [notFound, setNotFound] = useState(false);
  const [reloadToken, setReloadToken] = useState(0);
  const requestIdRef = useRef(0);

  useEffect(() => {
    if (communityLoading || !communityId || !programId || !enrollmentId) return;

    const requestId = ++requestIdRef.current;
    setLoading(true);
    setNotFound(false);

    (async () => {
      const res = await api.get(
        `community/${communityId}/mentoring/programs/${programId}/enrollments/${enrollmentId}`,
      );
      if (requestId !== requestIdRef.current) return;

      // The detail payload embeds the program (terms, application form,
      // contract), so a single request covers the whole page.
      const detail =
        res?.response?.status >= 400 ? null : adaptEnrollmentDetail(res?.data);

      if (!detail) {
        setEnrollment(null);
        setNotFound(true);
      } else {
        setEnrollment(detail);
      }
      setLoading(false);
    })();
  }, [communityLoading, communityId, programId, enrollmentId, reloadToken]);

  const refresh = useCallback(() => setReloadToken((token) => token + 1), []);

  return { enrollment, loading, notFound, currentCommunity, refresh };
}
